import type { SVGProps } from 'react';

import { unitMapping, type Unit } from '#src/lib/style.ts';

type SVGRProps = {
  size?: Unit;
  title?: string;
  titleId?: string;
};

export const Collection = ({
  size = 2,
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    style={{ width: unitMapping[size], height: unitMapping[size] }}
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M14.2222 1C15.1944 1 16 1.80556 16 2.77778V13.4444C16 14.4444 15.1944 15.2222 14.2222 15.2222H7.11111C6.11111 15.2222 5.33333 14.4444 5.33333 13.4444V2.77778C5.33333 1.80556 6.11111 1 7.11111 1H14.2222ZM2.66667 3C2.66667 2.63889 2.94444 2.33333 3.33333 2.33333C3.69444 2.33333 4 2.63889 4 3V13.2222C4 13.6111 3.69444 13.8889 3.33333 13.8889C2.94444 13.8889 2.66667 13.6111 2.66667 13.2222V3ZM0 4.33333C0 3.97222 0.277778 3.66667 0.666667 3.66667C1.02778 3.66667 1.33333 3.97222 1.33333 4.33333V11.8889C1.33333 12.2778 1.02778 12.5556 0.666667 12.5556C0.277778 12.5556 0 12.2778 0 11.8889V4.33333Z"
      fill="currentColor"
    />
  </svg>
);
